<div id="elevated-access-banner" class="">
  <div class="d-flex align-items-center container">
    <div class="flex-fill" >Elevated access</div>
    <div class="d-flex">
      <mat-icon class="close-icon" *ngIf="displayClose" (click)="onCloseClick()">close</mat-icon>
    </div>
  </div>
</div>
